import html2canvas from 'html2canvas-pro';
import { jsPDF } from 'jspdf';
import { defaultOpts } from './config';
import renderCanvas from './render-canvas';
import joinObject from './utils/joinObject';

import { getPageSize, pageBreaks, setContainer, toPx } from './page-break';
import { Options, PdfInstance } from './types';

// ----- jsPDF -----
function getPdf(opts: Options): PdfInstance {
  const { margin } = opts;
  const pdf = new jsPDF(opts.jsPDF);
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  const pdfContentWidth = pdfWidth - (margin.left + margin.right);
  const pdfContentHeight = pdfHeight - (margin.top + margin.bottom);
  const position = 0;
  const currentPage = 1;
  const pageOfCurrentNode = 1;
  return {
    pdf,
    pdfWidth,
    pdfHeight,
    pdfContentWidth,
    pdfContentHeight,
    position,
    currentPage,
    pageOfCurrentNode,
  };
}

export async function html2PDF(
  dom: HTMLElement | HTMLElement[],
  opts: Partial<Options> = {},
) {
  const finalOpts = joinObject<Options>(defaultOpts, opts);
  const pdfInstance = getPdf(finalOpts);
  // init pdf
  finalOpts.init.call(finalOpts, pdfInstance.pdf);

  const pageSize = getPageSize(finalOpts.jsPDF.orientation, finalOpts.jsPDF.unit, finalOpts.jsPDF.format as string);
  const height = pageSize.height - finalOpts.margin.top - (finalOpts.margin.bottom / 2);
  const inner = {
    width: pageSize.width,
    px: {
      height: toPx(height, pageSize.k),
    },
  };

  // multi pages by nodes
  if (Array.isArray(dom)) {
    for (const item of dom) {
      const [overlay, container] = setContainer(item, inner.width, pageSize.unit);
      pageBreaks(container, inner.px.height);
      const canvas = await html2canvas(container, finalOpts.html2canvas);
      renderCanvas(canvas, pdfInstance, finalOpts);
      document.body.removeChild(overlay);
    }
  } else {
    // single page for one node
    const [overlay, container] = setContainer(dom, inner.width, pageSize.unit);
    pageBreaks(container, inner.px.height);
    const canvas = await html2canvas(container, finalOpts.html2canvas);
    renderCanvas(canvas, pdfInstance, finalOpts);
    document.body.removeChild(overlay);
  }

  // save pdf
  finalOpts.success.call(finalOpts, pdfInstance.pdf);

  return pdfInstance.pdf;
}
